import React, { useState, useEffect } from "react";
import "./ProgressOverlay.css";

const ProgressOverlay = ({
  title = "Processing Your Benchmark",
  description = "Analysing web pages...",
  linkText = "Cardinal vs Competitors - Global Analysis 2025",
  totalTime = 20 * 60 * 1000, // 20 minutes default
  onClose,
  taskCompleted,
}) => {
  const [progress, setProgress] = useState(0);
  const [timeLeft, setTimeLeft] = useState(totalTime / 1000);
  const [minimized, setMinimized] = useState(false);

  useEffect(() => {
    if (taskCompleted) {
      onClose?.();
      return;
    }

    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      //   const newProgress = Math.min((elapsed / totalTime) * 100, 99);
      const speedMultiplier = 2; // 2x faster
      const newProgress = Math.min(
        (elapsed / (totalTime / speedMultiplier)) * 100,
        99
      );
      const remaining = Math.max(totalTime / 1000 - elapsed / 1000, 0);

      setProgress(newProgress);
      setTimeLeft(remaining);

      if (remaining <= 0) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [totalTime, taskCompleted, onClose]);

  const formattedTime = `${Math.ceil(timeLeft / 60)} min remaining`;

  return (
    <div className="progress-overlay">
      <div className={`progress-card ${minimized ? "minimized" : ""}`}>
        <div className="progress-header">
          <span className="progess_header_custom">{title}</span>
          <div className="actions">
            <button className="minimize_progress" onClick={() => setMinimized(!minimized)}>
              {minimized ? "▢" : "—"}
            </button>
            <button className="close_progress" onClick={onClose}>×</button>
          </div>
        </div>

        {!minimized && (
          <div className="progress-body">
            <div className="custom_analyaze_block">
            <p className="desc">{description}</p>
            <p className="link">{linkText}</p>

            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <p className="progress-info">
              {progress.toFixed(0)}% Complete • {formattedTime}
            </p>
          </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressOverlay;
